import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react'
import ColorClaritySelector from './colorClaritySelector';
import AgingReportInv from './AgingReport/AgingReportInv';
import AgingReport from './AgingReport/AgingReport';
import { FiExternalLink } from 'react-icons/fi';
import { DownloadIcon } from 'lucide-react/dist/cjs/lucide-react';
import { ColorRing } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import IntransitReport from './AgingReport/IntransitReport';

const StockAndSales = ({
    isAdmin,
    isMFG,
    drilldownRef,
    selectedCell,
    selectedGroupedCell,
    selectionMode,
    selectedShape,
    shapes,
    data,
    isCsr,
    shape,
    caratRange,
    selectedCaratRange,
    selectedColors,
    selectedClarities,
    selectedColorGroup,
    selectedClarityGroup,
    setSalesFilterKey,
    setInventoryFilterKey,
    // setQueryParams,
    caratRanges,
    handleShapeChange,
    handleCaratChange,
    handleColorChange,
    handleClarityChange,
    handleSelectionChange,
    handleSearchClick,
    salesFilter,
    inventoryFilter,
    inventoryFilterKey,
    salesFilterKey,
    colorGroupsApi,
    clarityGroupsApi
}) => {

  const shapes_others = ["0012square_emerald", "0013tapered_baguette", "0014baguette", "0015europeancut", "0016old_miner", "0017star", "0018rose", "0019half_moon", "0020square", "0023trapezoid", "0025briolette", "0026pentagonal", "0027hexagonal", "0028octagonal", "0029triangle", "0030trilliant", "0032shield", "0033lozenge", "0034kite", "0035round_modified_brilliant", "0036rectangular", "0037pear_rose_cut", "0038heart_rose_cut", "0045trapezoid_step_cut", "0049shield_step_cut", "0051oval_mixed_cut", "0052kite_mixed_cut", "0054round_cornered_rectangular_modified_brilliant", "0055pear_modified", "0056oval_modified", "0057heart_modified", "0058triangular_modified", "0059marquise_modified", "0060shield_modified", "0061hexagonal_modified", "0064other_shape"]
  const updateSearchParam = (key, values) => {
  const url = new URL(window.location);
  if (values?.length) {
    url.searchParams.set(key, values.join(','));
  } else {
    url.searchParams.delete(key); // Remove param if empty
  }
  window.history.replaceState({}, "", url);
};

const handleColorChangeWithURL = (newColors) => {
  handleColorChange(newColors); // your existing logic
  updateSearchParam("col", newColors);
};

const handleClarityChangeWithURL = (newClarities) => {
  handleClarityChange(newClarities); // your existing logic
  updateSearchParam("clr", newClarities);
};


  const [showInventoryReport, setShowInventoryReport] = useState(true);
  const [showIntransitReport, setShowIntransitReport] = useState(true);
  const [showSalesReport, setShowSalesReport] = useState(true);

  const summary  = useSelector((state => state.summary));

    if (inventoryFilter.filterHash.item_filter.discrete["diamond#shape"]?.includes("0007cushion_brilliant")) {
      inventoryFilter.filterHash.item_filter.discrete["diamond#shape"].push("0008cushion_modified");
    }

    if (inventoryFilter.filterHash.item_filter.discrete["diamond#shape"]?.includes("0064other_shape")) {
      inventoryFilter.filterHash.item_filter.discrete["diamond#shape"].push(...shapes_others);
    }

    if (salesFilter.filterHash.item_filter.discrete["diamond#shape"]?.includes("0007cushion_brilliant")) {
      salesFilter.filterHash.item_filter.discrete["diamond#shape"].push("0008cushion_modified");
    }

    if (salesFilter.filterHash.item_filter.discrete["diamond#shape"]?.includes("0064other_shape")) {
      salesFilter.filterHash.item_filter.discrete["diamond#shape"].push(...shapes_others);
    }
  
    const [downloadSale, setDownloadSale] = useState(false);
  return (
    <div className="drilldown">
          <div
            style={{
              paddingTop: "48px",
              paddingBottom: "40px",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            <div className="pagetitle text-center flex-col justify-center items-center" ref={drilldownRef}>
            <div className="flex justify-center items-center gap-4">
              <h1 className=" mb-7">
                STOCK AND SALES
              </h1>
              
              </div>  
              
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                {/* Shape Dropdown */}
                <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                  <InputLabel>Shape</InputLabel>
                  <Select
                    value={selectedShape || shape}
                    label="Shape"
                    onChange={(e) => {
                      // setNewSelectedShape(e.target.value);
                      // You might want to reset carat range or do other logic here
                      handleShapeChange(e.target.value)
                    }}
                  >
                    {shapes.map(shape => (
                      <MenuItem key={shape} value={shape}>
                        {data[shape].trans}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Carat Range Dropdown */}
                <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                  <InputLabel>Carat Range</InputLabel>
                  <Select
                    value={selectedCaratRange || caratRange}
                    label="Carat Range"
                    onChange={(e) => {
                      // setNewSelectedCaratRange(e.target.value);
                      // setQueryParams((prevParams) => ({
                      //       ...prevParams,
                      //       caratRange: e.target.value,
                      //     }));
                      handleCaratChange(e.target.value)
                    }}
                  >
                    {caratRanges.map(range => (
                      <MenuItem key={range} value={range}>
                        {range}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
               <ColorClaritySelector 
                  onSelectionChange={handleSelectionChange}
                  onColorChange={handleColorChangeWithURL}
                  onClarityChange={handleClarityChangeWithURL}
                  selectedCell={selectedCell}
                  setSalesFilterKey={setSalesFilterKey}
                  setInventoryFilterKey={setInventoryFilterKey}
                  selectedGroupedCell={selectedGroupedCell}
                  initialColor={ selectionMode !=="grouped" ? (selectedColors): (selectedColorGroup)}
                  initialClarity={selectionMode !=="grouped" ? (selectedClarities) : (selectedClarityGroup)}
               />

              </div>
        </div>
       <br />
          <div className="flex justify-between items-center py-1 rounded-md mb-4">
            <div className='flex gap-2 justify-between items-center'>
              <div className="flex justify-center items-center mb-2 hover:cursor-pointer  rounded-md">
                <div
                  className="text-black text-md underline"
                  onClick={() => setShowInventoryReport(prev => !prev)}
                >
                  {showInventoryReport ? <MdKeyboardArrowDown className="h-5 w-5" /> : <MdKeyboardArrowRight className="h-5 w-5"/>}
                </div>
              </div>
              <h4 className=" text-inherit text-2xl font-medium px-2">Inventory</h4>
               <div className="flex pb-1 justify-between items-center flex-wrap text-[0.75rem]">
                <div className="px-3 py-1  rounded-md  text-black ">
                  <span className="font-medium">COUNT:</span> {summary.selectedSummary?.inventory}
                </div>
                <div className="px-3 py-1  rounded-md text-black ">
                  <span className="font-medium">VALUE:</span> {summary.selectedSummary?.inv_value}
                </div>
                <div className="px-3 py-1  rounded-md text-black ">
                  <span className="font-medium">AVG AGING:</span> {summary.selectedSummary?.inv_aging}
                </div>
              </div>
            </div>
              <button 
                  className="px-4 py-2 text-blue-500 flex gap-2 items-center bg-white rounded-md border hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
                  onClick={() => handleSearchClick( (salesFilter.filterHash))}
                >
                Pricing Co-Pilot  <FiExternalLink />
              </button>
          </div>   
            <AgingReportInv
              key={`inventory-${inventoryFilterKey}`}
              id={"BI-Table_Values"}
              isCsr={isCsr}
              filterHash={inventoryFilter.filterHash}
              rowFilter={salesFilter.rowFilter}
              showInventoryReport={showInventoryReport}
            />
          
          
          <div className="flex justify-between items-center py-1">
            <div className='flex gap-1 justify-between items-center'>
              <div className="flex justify-center items-center mb-2 mr-2 hover:cursor-pointer  rounded-md">
                <div
                  className="text-black text-md underline"
                  onClick={() => setShowSalesReport(prev => !prev)}
                >
                  {showSalesReport ? <MdKeyboardArrowDown className="h-5 w-5" /> : <MdKeyboardArrowRight className="h-5 w-5"/>}
                </div>
              </div>
              <h4 className=" text-inherit text-2xl font-medium px-1">Sales</h4>
            
              <div className=" pl-[3.25rem] flex pb-1 justify-between items-center flex-wrap text-[0.75rem]">
                <div className="px-3 py-1  rounded-md  text-black ">
                  <span className="font-medium">COUNT:</span> {summary.selectedSaleSummary?.sales}
                </div>
                <div className="px-3 py-1  rounded-md text-black ">
                  <span className="font-medium">VALUE:</span> {summary.selectedSaleSummary?.sold_value}
                </div>
                <div className="px-3 py-1  rounded-md text-black ">
                  <span className="font-medium">AVG AGING:</span> {summary.selectedSaleSummary?.sold_aging}
                </div>
              </div>
            </div>
              <button
                className="border-[1px] rounded-md bg-transparent font-medium text-[0.75rem] border-[#1E90FF] h-8 text-[#1E90FF] px-2 gap-[0.200rem] flex justify-center items-center disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => setDownloadSale(true)}
                disabled={downloadSale} // Disable button when downloadSale is true
              >
                {downloadSale ? (
                  <>
                    <ColorRing
                      visible={true}
                      height="30"
                      width="30"
                      ariaLabel="blocks-loading"
                      wrapperStyle={{}}
                      wrapperClass="blocks-wrapper"
                      colors={["#00319f", "#2e56b1", "#5c7bc2", "#8aa1d3", "#b2c1e2"]}
                    />
                    Downloading
                  </>
                ) : (
                  <>
                    <DownloadIcon className="h-4 w-4" /> Download
                  </>
                )}
              </button>
            </div>
            {/* <div className="max-h-[1048px] overflow-y-auto" style={{ textDecoration: 'none'}}> */}
            <AgingReport
              key={`sales-${salesFilterKey}`}
              rmToggle={true}
              id={"stock-performance"}
              isAdmin={isAdmin}
              isCsr={isCsr}
              filterHash={salesFilter.filterHash}
              rowFilter={salesFilter.rowFilter}
              downloadSale={downloadSale}
              setDownloadSale={setDownloadSale}
              showSalesReport={showSalesReport}
              
            />
            {/* </div> */}
          {isMFG && (
            <>
              <div className="flex justify-between items-center py-1 rounded-md my-4">
              <div className='flex gap-2 justify-between items-center'>
                <div className="flex justify-center items-center mb-2 hover:cursor-pointer  rounded-md">
                  <div
                    className="text-black text-md underline"
                    onClick={() => setShowIntransitReport(prev => !prev)}
                  >
                    {showIntransitReport ? <MdKeyboardArrowDown className="h-5 w-5" /> : <MdKeyboardArrowRight className="h-5 w-5"/>}
                  </div>
                </div>
                <h4 className=" text-inherit text-2xl font-medium px-2">Intransit</h4>
                <div className="flex pb-1 justify-between items-center flex-wrap text-[0.75rem]">
                  <div className="px-3 py-1  rounded-md  text-black ">
                    <span className="font-medium">COUNT:</span> {summary.selectedIntransitSummary?.intransit}
                  </div>
                </div>
              </div>
            </div>   
              <IntransitReport
                key={`inventorymfg-${inventoryFilterKey}`}
                id={"BI-Table_Values"}
                isCsr={isCsr}
                filterHash={inventoryFilter.filterHash}
                rowFilter={salesFilter.rowFilter}
                showInventoryReport={showIntransitReport}
              />
            </>
          )}  
            
        </div>
      </div>
  )
}

export default StockAndSales